import { shape, string } from 'prop-types'

const VideoProp = shape({
  title: string,
  thumbnail: string,
  source: string,
  description: string,
})

export default VideoProp
